import type { BaseMessage, ToolResultMessage } from "@/modules/messages";
import type { ImageAttachment, Instance, ModelType, OutputLog } from "@/server/types";

// Connection timeout: 60 seconds (3 missed heartbeats at 20s interval)
export const DISCONNECT_THRESHOLD = 60000;

export type UserCommandItem = {
  kind: "user_command";
  id: number | string;
  timestamp: number;
  content: string;
  model?: ModelType | null;
  planMode?: boolean;
  images?: ImageAttachment[];
};

export type ClaudeMessageItem = {
  kind: "claude_message";
  id: number | string;
  timestamp: number;
  message: BaseMessage;
  inlineResults?: ToolResultMessage[];
};

export type DisplayItem = UserCommandItem | ClaudeMessageItem;

export interface DisplayLog extends OutputLog {
  isUserCommand?: boolean;
}
